import type { ReactNode } from 'react'
import { Link, Navigate } from 'react-router-dom'

import { useAuth } from '../auth/AuthProvider'
import { isOperatorUser } from '../auth/routing'

export { isOperatorUser } from '../auth/routing'

export const RequireOperator = ({ children }: { children: ReactNode }) => {
  const { session, loading, userRoles } = useAuth()

  if (loading) {
    return (
      <main className="market-login">
        <p className="market-muted">Загрузка…</p>
      </main>
    )
  }

  if (!session) {
    return <Navigate to="/login" replace />
  }

  if (!isOperatorUser(userRoles)) {
    return (
      <main className="market-login">
        <div className="market-panel market-panel--narrow">
          <h1 className="market-panel__title">Доступ запрещён</h1>
          <p className="market-muted">Этот раздел доступен только операторам Провизиум.</p>
          <p className="market-muted">
            <Link to="/overview">Вернуться в личный кабинет</Link>
          </p>
        </div>
      </main>
    )
  }

  return children
}
